// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__2nEHE","upload":"Small_upload__3alfX","imageWrap":"Small_imageWrap__2tnE6","removeBtn":"Small_removeBtn__3lbEs"};